import { nextTick } from 'process'
import { Component, Vue } from 'vue-property-decorator'
import CACG1060ViewModel from './CACG1060ViewModel'
import CACG1060Service from './CACG1060Service'
import CACG1080ParamModel from '../CACG1080/CACG1080ParamModel'
import CACG1070ParamModel from '../CACG1070/CACG1070ParamModel'
import SessionStorageService from '@/common/SessionStorageService'
import TransportService from '@/common/TransportService'
import { FormatConstants } from '@/common/FormatConstants'
import CommonConstants from '@/common/CommonConstants'
import ShowMore from '@/assets/js/components/show-more.js'
import { fixedContent } from '@/assets/js/main.js'
import Numeral from 'numeral'

import 'simplebar'
import 'simplebar/dist/simplebar.css'

@Component({
  name: 'CACG1060',
  components: {}
  })
export default class CACG1060Controller extends Vue {
  private FormatConstants = FormatConstants
  private MONTH_OF_YEAR = 12
  private cacg1060ViewModel: CACG1060ViewModel = {
    productNo: '',
    shhnCd: '',
    productNameInformal: '',
    productDivName: '',
    investTrustProductCritValCritDayLst: [
      {
        critValCritDay: '',
        critVal: null,
        critValBeforeDayCompre: null,
        asset: null
      }
    ],
    investTrustProductLast10YearDataLst: [
      {
        refYearMonth: '',
        critVal: null,
        rtnMon: null
      }
    ],
    moreInterestRate: 1
  }

  private cacg1060Service = new CACG1060Service()

  /**
   * 画面要素描画後処理
   */
  async mounted() {
    fixedContent()
    await this.init()
    nextTick(() => {
      fixedContent()
    })
    this.clickExpandOrFoldMore()
  }

  /**
   * 初期処理
   */
  private async init() {
    const productNo = JSON.parse(
      JSON.stringify(this.$route.query.productNo || '')
    )
    const shhnCd = JSON.parse(JSON.stringify(this.$route.query.shhnCd || ''))

    this.cacg1060ViewModel.productNo = productNo
    this.cacg1060ViewModel.shhnCd = shhnCd
    const params = `shhnCd=${this.cacg1060ViewModel.shhnCd}`
    const [
      caca1060ResponseModel,
      transportResponseModel
    ] = await Promise.all([
      this.cacg1060Service.callAPICACA1060(
        productNo,
        shhnCd
      ),
      // 稼働／閲覧統計ログを実行する
      TransportService.callAPITransportWithLogMode(CommonConstants.URL_CACG1060, null, params, CommonConstants.LOG_MODE_ACCESS_ONLY)
    ])

    if (caca1060ResponseModel.redirectRiv === 7) {
      const messageError = caca1060ResponseModel?.common?.errors
      messageError.forEach((item) => {
        Object.assign(item, { url: '' })
      })
      SessionStorageService.setItem(
        CommonConstants.MESSAGE_ERROR,
        JSON.stringify(messageError)
      )
      this.$router.push({
        name: 'cacg0070'
      })
    }

    this.cacg1060ViewModel.productNameInformal =
      caca1060ResponseModel.productNameInformal
    this.cacg1060ViewModel.productDivName = caca1060ResponseModel.productDivName

    if (caca1060ResponseModel.investTrustProductCritValCritDayLst) {
      const dataResponse =
        caca1060ResponseModel.investTrustProductCritValCritDayLst.map(
          (item) => {
            return {
              ...item
            }
          }
        )
      this.cacg1060ViewModel.investTrustProductCritValCritDayLst = dataResponse
    } else {
      this.cacg1060ViewModel.investTrustProductCritValCritDayLst = null
    }

    if (caca1060ResponseModel.investTrustProductLast10YearDataLst) {
      const dataResponse =
        caca1060ResponseModel.investTrustProductLast10YearDataLst.map((x) => {
          if (x.rtnMon) {
            x.rtnMon =
              this.cacg1060ViewModel.productDivName === '年金投資基金信託'
                ? x.rtnMon
                : Numeral(x.rtnMon).multiply(100).value()
          }
          return {
            ...x
          }
        })
      this.cacg1060ViewModel.investTrustProductLast10YearDataLst = dataResponse
    } else {
      this.cacg1060ViewModel.investTrustProductLast10YearDataLst = null
    }
  }

  /**
   * もっと見るの展開・折畳
   */
  private clickExpandOrFoldMore() {
    if (
      (this.cacg1060ViewModel.investTrustProductLast10YearDataLst?.length >
        this.MONTH_OF_YEAR &&
        this.cacg1060ViewModel.investTrustProductLast10YearDataLst?.length >
          this.MONTH_OF_YEAR * this.cacg1060ViewModel.moreInterestRate) ||
      (this.cacg1060ViewModel.investTrustProductLast10YearDataLst?.length >
        this.MONTH_OF_YEAR &&
        this.cacg1060ViewModel.investTrustProductLast10YearDataLst?.length <=
          this.MONTH_OF_YEAR * this.cacg1060ViewModel.moreInterestRate)
    ) {
      ShowMore()
    }
  }

  /**
   * 資料タブ切り替え
   */
  private gotoCACG1070() {
    const cacg1070ParamModel: CACG1070ParamModel = {
      productNo: this.cacg1060ViewModel.productNo,
      shhnCd: this.cacg1060ViewModel.shhnCd
    }
    this.$router.push({
      name: 'cacg1070',
      query: cacg1070ParamModel
    })
  }

  /**
   * チャートタブ切り替え
   */
  private gotoCACG1080() {
    const cacg1080ParamModel: CACG1080ParamModel = {
      productNo: this.cacg1060ViewModel.productNo,
      shhnCd: this.cacg1060ViewModel.shhnCd
    }
    this.$router.push({
      name: 'cacg1080',
      query: cacg1080ParamModel
    })
  }

  /**
   * 運用商品ラインアップに戻るリンク押下
   */
  private gotoCACG1010() {
    this.$router.push({ name: 'cacg1010' })
  }
}
